import React, { useState } from 'react';
import { signIn, signUp, confirmSignUp } from 'aws-amplify/auth';

export default function LoginScreen({ onLogin, demoMode }) {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDemoLogin = () => onLogin({ username: 'demo@jobtrack.app', userId: 'demo-user-001' });

  const handleLogin = async (e) => {
    e.preventDefault();
    if (demoMode) { handleDemoLogin(); return; }
    setLoading(true); setError('');
    try {
      const result = await signIn({ username: email, password });
      if (result.isSignedIn) onLogin({ username: email, userId: result.userId });
    } catch (err) { setError(err.message || 'Login failed.'); }
    finally { setLoading(false); }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await signUp({ username: email, password, options: { userAttributes: { email } } });
      setMode('confirm');
    } catch (err) { setError(err.message || 'Sign up failed.'); }
    finally { setLoading(false); }
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try { await confirmSignUp({ username: email, confirmationCode: code }); setMode('login'); }
    catch (err) { setError(err.message || 'Confirmation failed.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-screen">
      <div style={{ textAlign: 'center' }}>
        <div className="login-logo">JOBTRACK</div>
        <div className="login-tagline">Construction Expense Tracker</div>
      </div>

      {demoMode && (
        <div style={{ background: 'rgba(230,194,58,0.1)', border: '1px solid rgba(230,194,58,0.3)', borderRadius: '10px', padding: '12px 16px', marginBottom: '24px', fontSize: '13px', color: '#e6c23a', maxWidth: '360px', textAlign: 'center' }}>
          ⚡ Demo Mode — tap "Enter App" to explore with sample data
        </div>
      )}

      <form className="login-form" onSubmit={mode === 'login' ? handleLogin : mode === 'signup' ? handleSignUp : handleConfirm}>
        {mode !== 'confirm' && (
          <>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input className="form-input" type="password" placeholder={mode === 'signup' ? 'Min 8 characters' : '••••••••'} value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
          </>
        )}

        {mode === 'confirm' && (
          <div className="form-group">
            <label className="form-label">Confirmation Code</label>
            <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '10px' }}>Check your email for a 6-digit code</p>
            <input className="form-input" type="text" placeholder="123456" value={code} onChange={e => setCode(e.target.value)} style={{ letterSpacing: '4px', textAlign: 'center', fontSize: '20px' }} maxLength={6} />
          </div>
        )}

        {error && <div style={{ color: 'var(--accent-red)', fontSize: '13px', marginBottom: '12px', textAlign: 'center' }}>{error}</div>}

        <button className="btn btn--primary" type="submit" disabled={loading} style={{ marginBottom: '12px' }}>
          {loading ? <span className="spinner" style={{ width: '20px', height: '20px', borderTopColor: 'white', borderColor: 'rgba(255,255,255,0.3)' }} /> :
            mode === 'login' ? (demoMode ? 'Enter App' : 'Sign In') :
            mode === 'signup' ? 'Create Account' : 'Verify Email'}
        </button>

        {mode === 'login' && !demoMode && (
          <button type="button" className="btn btn--secondary" onClick={() => setMode('signup')}>Create Account</button>
        )}
        {mode === 'signup' && (
          <button type="button" className="btn btn--secondary" onClick={() => setMode('login')}>Already have an account</button>
        )}
      </form>
    </div>
  );
}
